import { Scanner } from "@yudiel/react-qr-scanner";
import { useNavigate } from "react-router-dom";

const QRScanner = () => {
  const navigate = useNavigate();

  const handleScan = (data: any) => {
    if (data.length > 0) {
      navigate(`/product/?id=${data[0]?.rawValue?.split("=")[1]}`);
    }
  };

  return (
    <>
      <Scanner onScan={handleScan} />
    </>
  );
};

export default QRScanner;
